import type { VersionsModel } from '@/common/models/versions.model';

export default defineNuxtPlugin(() => {
  const route = useRoute();
  const { f, ver, hp, l, p, mixmin } = route.query;
  const versions = ref<VersionsModel>({
    paymentForm: f as string,
    quiz: ver as string,
    homePage: hp as string,
    landing: l as string,
    upsale: p as string,
    trackOnlyAfterQuiz: mixmin === '1' ? '0' : '1',
  });

  async function setVersions(generatedVersion: VersionsModel): Promise<VersionsModel> {
    const store = useKegelAnalyticStore();
    versions.value = generatedVersion;
    store.versions = generatedVersion;

    return versions.value;
  }

  return {
    provide: {
      versions,
      setVersions,
    },
  };
});
